// ---------------------------------------------------------------------------
// leftoverTerms.js
// Templates built for supplement campaigns carry wording that makes no sense
// for other products ("Supps", "ingredients", "dosage"...). This scans a
// finished page's readable text (visible text, meta content, schema) and
// returns any such words still present, so they can be reported in the log.
// URLs, CSS, scripts and technical attributes are ignored.
// ---------------------------------------------------------------------------

const SUPPLEMENT_TERMS = /(?<![A-Za-z])(supps?|supplements?|ingredients?|dosages?|capsules?|gumm(?:y|ies)|allergens?|gluten|non-gmo|gmp|fda|metabolic|metabolism|side effects?|vitamins?)(?![A-Za-z])/gi;

/** True when the researched product really is a supplement/health product. */
export const isSupplementCategory = (text) =>
  /supplement|vitamin|capsule|gumm|formula|nutrition|health|wellness|diet|weight loss/i.test(text || '');

/**
 * @param {string} html - a finished page
 * @returns {{term: string, count: number}[]} supplement words still readable on the page
 */
export const findSupplementTerms = (html) => {
  const readable = String(html || '')
    .replace(/<style\b[\s\S]*?<\/style>/gi, ' ')
    .replace(/<script\b(?![^>]*application\/(?:ld\+)?json)[\s\S]*?<\/script>/gi, ' ')
    .replace(/\b(?:href|src|class|id|rel|type)="[^"]*"/gi, ' ')
    .replace(/(?:https?:)?\/\/[^\s"'<>)]+/gi, ' ');
  const counts = new Map();
  for (const match of readable.matchAll(SUPPLEMENT_TERMS)) {
    const term = match[1].toLowerCase();
    counts.set(term, (counts.get(term) || 0) + 1);
  }
  return [...counts.entries()].map(([term, count]) => ({ term, count }));
};
